// Organiser l'écran dans l'appli des parents, en français (voir boardConfigApp.nl.ts).
export const appBoardConfigFr = {
    open: 'Organiser l’écran',
    title: 'Organiser l’écran',
    intro: 'Déplacez les widgets dans la grille et rendez-les plus étroits, plus larges, plus bas ou plus hauts : plus ils sont grands, plus ils en montrent. Un tableau a jusqu’à 12 pages ; sur le tableau, glissez sur le côté pour passer à la suivante.',
    standard: 'Ce tableau affiche la disposition standard. Changez quelque chose pour créer la vôtre.',
    onBoard: 'Sur le tableau',
    available: 'Ajouter',
    nothingToAdd: 'Tous les widgets de vos modules y sont déjà.',
    empty: 'Rien sur cette page pour l’instant. Ajoutez quelque chose ci-dessous.',
    size: 'Taille',
    style: 'Style',
    moveUp: 'Monter {name}',
    moveDown: 'Descendre {name}',
    remove: 'Retirer {name}',
    pageEarlier: 'Avancer {name}',
    pageLater: 'Reculer {name}',
    pageRemove: 'Retirer {name}',
    onPage: 'Sur {name}',
    weekSketch: 'L’agenda de la semaine',
    phoneHint: 'Déplacer et redimensionner se fait sur une tablette ou un ordinateur. Ici, vous choisissez ce qui figure sur chaque page.',
    add: 'Ajouter {name}',
    reset: 'Disposition standard',
    save: 'Enregistrer',
    saved: 'Enregistré. Le tableau s’adapte en une minute.',
    resetDone: 'La disposition standard est prête. Enregistrez pour la mettre sur le tableau.',
    failed: 'L’enregistrement a échoué. Réessayez dans un instant.',
    conflict: 'Ce tableau a été modifié entre-temps, peut-être sur le tableau lui-même. La disposition la plus récente est affichée.',
    preview: 'Aperçu',
    previewNote: 'Avec des données d’exemple ; le tableau utilise les vôtres.',
    screen: 'Écran',
    screens: { large: 'iPad', wide: 'Tablette large', compact: 'Petite tablette' },
    gestureTitle: 'Ajuster sur le tableau lui-même',
    gestureBody: 'Touchez trois fois rapidement l’horloge du tableau et saisissez votre PIN parent. Se ferme tout seul après une minute sans toucher.',
    pinTitle: 'Mon code parental',
    pinBody: 'Utilisez votre propre code. Chaque parent a son code personnel.',
    pinLabel: 'Nouveau PIN parent',
    pinSave: 'Enregistrer le PIN',
    pinSaved: 'Votre PIN parent est enregistré.',
    pinInvalid: 'Choisissez 4 à 6 chiffres.',
    pinTaken: 'Un autre parent utilise déjà ce code PIN. Choisissez-en un autre.',
    back: 'Retour aux tablettes',
    names: {
        prayer: 'Horaires de prière',
        weather: 'Météo',
        tasks: 'Tâches',
        rides: 'Déposer et chercher',
        meals: 'Repas',
        upcoming: 'Bientôt',
        messages: 'Messages',
        memorize: 'Apprendre les sourates',
        dinner: 'Qui mange avec nous',
        bookings: 'Réserver',
        precip: 'Précipitations',
        week: 'Semaine (min. et max.)',
        quran: 'Écouter le Coran',
        todos: 'Choses à faire',
        notes: 'Notes',
        // 0068: Gezond op gewicht.
        kompas: 'Bonnes habitudes (Poids en forme)',
        // 0076: schoolplanner (nooit een cijfer op het bord).
        school: 'École (devoirs et contrôles)',
        // 0062: module Jodendom.
        shabbat: 'Chabbat et calendrier',
        // 0061: Kerk & kalender.
        seasons: 'Église & calendrier',
        // 0063: module Hindoeïsme.
        almanac: 'Panchang et fêtes',
        // UX-ronde bord: Boodschappen (module Eten) en Beloningen.
        groceries: 'Courses',
        rewards: 'Récompenses',
        // 0075: Huisronde (module Eten).
        house_round: 'Tour de la maison',
        // Widgets compleet: Wensen, Foto (Fotolijst), Timer, Schoonmaak en Beurtrooster.
        wishes: 'Souhaits',
        photo: 'Photo (Cadre photo)',
        timer: 'Minuteur',
        cleaning: 'Ménage',
        rotation: 'Tour de rôle',
        // Widgets privé (0077): de gewone nieuwe widgets en de privé-widgets.
        clock: 'Horloge',
        travel: 'Départ',
        stock: 'Réserve',
        cookbook: 'Carnet de cuisine',
        reminders: 'Rappels',
        checkin: 'Check-in',
        fasting: 'Jeûne',
        growth: 'Croissance',
        money: 'Finances',
        expenses: 'Frais partagés',
        my_todos: 'Tâches privées',
        circle: 'Cercle familial',
    },
    sizes: { S: 'Petit', M: 'Moyen', L: 'Grand', XL: 'Très grand' },
    sizeHints: {
        S: 'L’essentiel en un coup d’œil',
        M: 'Aujourd’hui',
        L: 'Aujourd’hui et demain, plus en détail',
        XL: 'Tout, sur un écran large',
    },
    /** Fijnslijpen ouderapp: Brengen en halen, de ophaaltijd als schakelaar (stijl list of no_pickup). */
    ridesPickup: 'Afficher l’heure de retour',
    ridesPickupHint: 'Par exemple « Papa va chercher 16:50 ». Désactivé : seulement qui va chercher.',
    styles: {
        // Widget Foto.
        slideshow: 'Change chaque minute',
        daily: 'Photo du jour',
        no_pickup: 'Sans heure de retour',
        list: 'Liste',
        ring: 'Horloge',
        compact: 'Compact',
        illustrated: 'Illustré',
        today: 'Aujourd’hui seulement',
        bars: 'Barres',
    },
    /** Koran luisteren: "Over de opnames" bij de widget. */
    quran: {
        aboutTitle: 'À propos des enregistrements',
        aboutBody: 'Récitation par {name}. Source : {source}.',
        familyOnly: 'Aucune licence connue : ces enregistrements sont réservés à votre famille.',
        none: 'Pas encore d’enregistrements pour votre famille.',
    },
    /** Voorbeeldgezin in het voorbeeld van "Scherm inrichten" (kiosk-ui widgets/sample.ts). */
    samples: {
        // Widgets compleet: wensen, klussen en een bijschrift van het voorbeeldgezin.
        wishLego: 'Vaisseau spatial Lego',
        wishBook: 'Livre sur les animaux',
        wishSkates: 'Rollers',
        choreBathroom: 'Salle de bain',
        choreVacuum: 'Passer l’aspirateur',
        choreBins: 'Sortir les poubelles',
        photoCaption: 'L’été à la mer',
        school: 'École',
        swimming: 'Cours de natation',
        judo: 'Judo',
        brushTeeth: 'Se brosser les dents',
        packBag: 'Préparer son sac',
        makeBed: 'Faire son lit',
        setTable: 'Mettre la table',
        groceries: 'Courses',
        birthday: 'Noor a 8 ans',
        autumnBreak: 'Vacances de la Toussaint',
        pasta: 'Pâtes au pesto',
        soup: 'Soupe',
        curry: 'Curry',
        pancakes: 'Crêpes',
        pizza: 'Pizza',
        stew: 'Pot-au-feu',
        inHours: '{n} h',
        paintCupboard: 'Peindre le meuble à chaussures',
        fixBike: 'Réparer le pneu du vélo',
        clearGutter: 'Nettoyer la gouttière',
        noteMilk: 'Il n’y a plus de lait',
        noteSwim: 'N’oublie pas le sac de piscine',
        // UX-ronde bord: voorbeeld voor de widgets Boodschappen en Beloningen.
        milk: 'Lait',
        bread: 'Pain',
        apples: 'Pommes',
        cheese: 'Fromage',
        cinema: 'Cinéma',
    },
};
//# sourceMappingURL=boardConfigApp.fr.js.map